import { Component, Input, OnChanges } from '@angular/core';

type Tone = 'success' | 'info' | 'warning' | 'danger' | 'neutral';

const TONE_BY_KEYWORD: Array<{ match: RegExp; tone: Tone }> = [
  { match: /published/i, tone: 'success' },
  { match: /completed/i, tone: 'success' },
  { match: /rejected/i, tone: 'danger' },
  { match: /deleted/i, tone: 'danger' },
  { match: /inactive/i, tone: 'neutral' },
  { match: /pending|inprocess|in process/i, tone: 'warning' },
  { match: /available|with /i, tone: 'info' }
];

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent implements OnChanges {
  @Input() status = '';

  tone: Tone = 'neutral';

  ngOnChanges(): void {
    this.tone = TONE_BY_KEYWORD.find((entry) => entry.match.test(this.status))?.tone ?? 'neutral';
  }
}
